export function excludeCustomFields(destinationParametersAndFields, _sourceStepId) {
  const filteredCustomFields = destinationParametersAndFields.filter((item) => {
    if (item.MappingType === 'CycleVariable') {
      return false
    } else if (item.SourceStepId) {
      const isSameSourceStep = item.SourceStepId === _sourceStepId
      return isSameSourceStep
    } else {
      return true
    }
  })

  return filteredCustomFields
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CyclrCustomFieldForm/utils.js